// src/features/whatsapp/pages/MembershipExpiringPage.tsx
// Membresías F4 (20-oct-2026): aviso «por vencer» que manda el cron (lib/membershipNotices.js) una vez por membresía,
// unos días antes o cuando queden pocos productos. Canal excluyente: correo (por defecto) o WhatsApp. Se enciende por
// PLAN desde Membresías (interruptor «Avisar al cliente»); aquí solo el texto y el canal.
import React from 'react';
import { BadgeCheck } from 'lucide-react';
import EventMessageEditor from '../components/EventMessageEditor';

const MembershipExpiringPage: React.FC = () => (
  <EventMessageEditor
    eventKey="membership_expiring"
    title="Aviso de Membresía por Vencer"
    subtitle="Avísale a cada miembro, una sola vez, cuando su membresía esté por vencer para que renueve a tiempo"
    icon={<BadgeCheck className="h-5 w-5 sm:h-6 sm:w-6 mr-2 text-emerald-500" />}
    feature="Avisos de membresía"
    defaultTemplate="Hola @nombre 👋 Tu membresía @membresia en @negocio vence @vence (te quedan @restantes). Pasa a renovarla y sigue disfrutando tus beneficios 🎟️"
    variables={[
      { key: '@nombre', label: 'Nombre del cliente', example: 'María' },
      { key: '@membresia', label: 'Nombre del plan', example: 'Club del Café' },
      { key: '@vence', label: 'Cuándo vence', example: 'el 19 nov' },
      { key: '@restantes', label: 'Lo que le queda', example: '7 días' },
      { key: '@negocio', label: 'Nombre de tu negocio', example: 'tu negocio', aliases: ['@marca'] },
    ]}
    enabledHint={{ on: 'Los miembros con aviso encendido en su plan reciben este mensaje', off: 'Activar para avisar a los miembros antes de que venza su membresía' }}
    stepGuide={{
      description: 'Cada día el sistema revisa las membresías vigentes: si una está por vencer (7 días antes en planes de un mes o más, 2 días en planes cortos, o cuando queden pocos productos del cupo) y su plan tiene el aviso encendido, le manda este mensaje una sola vez. Al renovar, vuelve a contar.',
      steps: ['Membresía por vencer', 'Plan con aviso encendido', 'Correo o WhatsApp al cliente'],
    }}
    requirementsReady="Todo listo — tus miembros recibirán el aviso antes de que venza su membresía"
    emailWithoutWhatsapp
    emailChannel={{ defaultSubject: 'Tu membresía @membresia vence @vence' }}
  />
);

export default MembershipExpiringPage;
